<template>
  <div class="date-time-info-contanier">
    <b-row>
      <b-col md="7" v-if="is_event_recurring == 1">
        <b-row>
          <b-col md="6">
            <b-form-group
              :class="{
                'form-group-vselect-doomyoga': client_name == 'DY',
                'form-group-vselect-mid': client_name == 'MID',
              }"
              label="Recurrence"
              label-for="recurrence"
              :recurrence="recurrence"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <v-select
                :options="recurrence_options"
                name="recurrence"
                title="recurrence"
                v-model="_recurrence"
                placeholder="Select recurrence"
                :reduce="(item) => item.code"
                required
                :clearable="false"
              ></v-select
            ></b-form-group>
          </b-col>
          <b-col md="6" v-if="recurrence == 'day' || recurrence == 'week'">
            <b-form-group
              :class="{
                'form-group-vselect-doomyoga': client_name == 'DY',
                'form-group-vselect-mid': client_name == 'MID',
              }"
              label="Repeat every"
              label-for="repeat"
              :repeat="repeat"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <v-select
                :options="optionsRecurrenceDaily"
                name="repeat"
                title="repeat"
                v-model="_repeat"
                placeholder="Select repeat every"
                class="repeatEverySelect"
                :class="{
                  repeatEverySelectDY: client_name == 'DY',
                  repeatEverySelectMID: client_name == 'MID',
                }"
                :clearable="false"
                required
              ></v-select>
              <span
                class="repeatEverySpan"
                :class="{
                  repeatEverySpanDY: client_name == 'DY',
                  repeatEverySpanMID: client_name == 'MID',
                }"
                v-if="recurrence == 'day'"
                >day
              </span>
              <span
                class="repeatEverySpan"
                :class="{
                  repeatEverySpanDY: client_name == 'DY',
                  repeatEverySpanMID: client_name == 'MID',
                }"
                v-if="recurrence == 'week'"
                >week
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="recurrence == 'month'">
            <b-form-group
              :class="{
                'form-group-vselect-doomyoga': client_name == 'DY',
                'form-group-vselect-mid': client_name == 'MID',
              }"
              label="Repeat every"
              label-for="repeat"
              :repeat="repeat"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <v-select
                :options="optionsRecurrenceMonthly"
                name="repeat"
                title="repeat"
                v-model="_repeat"
                placeholder="Select repeat every"
                class="repeatEverySelect"
                :class="{
                  repeatEverySelectDY: client_name == 'DY',
                  repeatEverySelectMID: client_name == 'MID',
                }"
                required
                :clearable="false"
              ></v-select>
              <span
                class="repeatEverySpan"
                :class="{
                  repeatEverySpanDY: client_name == 'DY',
                  repeatEverySpanMID: client_name == 'MID',
                }"
                >month
              </span>
            </b-form-group>
          </b-col>
        </b-row></b-col
      ></b-row
    >
    <b-row v-if="recurrence == 'week'">
      <b-col md="6">
        <b-row>
          <b-col>
            <b-form-group
              class="form-group-checkbox-group"
              :class="{
                'form-group-checkbox-group-doomyoga': client_name == 'DY',
                'form-group-checkbox-group-mid': client_name == 'MID',
              }"
              label="Occurs on"
              v-slot="{ ariaDescribedby }"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_occurs_on"
              >
                Please select day(s)
              </p>
              <b-form-checkbox-group
                id="occursOnCheckboxGroup"
                v-model="_occurs_on"
                :options="occurs_on_days"
                :aria-describedby="ariaDescribedby"
                name="occurs_on"
              ></b-form-checkbox-group> </b-form-group
          ></b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="recurrence == 'month'">
      <b-col md="6">
        <b-row>
          <b-col>
            <b-form-group
              :class="{
                'form-group-vselect-doomyoga': client_name == 'DY',
                'form-group-vselect-mid': client_name == 'MID',
              }"
              label="Occurs on"
              label-for="occurs_on_month"
              :occurs_on_month="occurs_on_month"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_occurs_on_month"
              >
                Please select day of month
              </p>
              <span
                class="repeatEverySpan"
                :class="{
                  repeatEverySpanDY: client_name == 'DY',
                  repeatEverySpanMID: client_name == 'MID',
                }"
                >Day
              </span>

              <v-select
                :options="occurs_on_day_month"
                name="occurs_on_month"
                title="occurs_on_month"
                v-model="_occurs_on_month"
                placeholder="Select day of month"
                class="repeatEverySelect"
                :class="{
                  repeatEverySelectDY: client_name == 'DY',
                  repeatEverySelectMID: client_name == 'MID',
                }"
                style="width: auto"
                required
                :clearable="false"
              ></v-select>
              <span
                class="repeatEverySpan"
                :class="{
                  repeatEverySpanDY: client_name == 'DY',
                  repeatEverySpanMID: client_name == 'MID',
                }"
              >
                of the month
              </span>
            </b-form-group></b-col
          >
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="6"
        v-if="is_event_recurring == 1 && recurrence != 'no_fixed_time'"
      >
        <b-row>
          <b-col>
            <b-form-group
              label="Start date"
              label-for="event_start_date"
              :event_start_date="event_start_date"
              class="form-group-event-date"
              :class="{
                'm-date-picker-doomyoga': client_name == 'DY',
                'm-date-picker-mid': client_name == 'MID',
              }"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_start_date"
              >
                Please select date
              </p>
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_select_start_date"
              >
                Please select future date
              </p>
              <mDatePicker
                v-model="_event_start_date"
                :multi="multidate"
                :format="formatDate"
                lang="en"
                :disp="[
                  'Sun',
                  'Mon',
                  'Tue',
                  'Wed',
                  'Thu',
                  'Fri',
                  'Sat',
                  '',
                  '',
                  'Cancel',
                  'OK',
                ]"
              ></mDatePicker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="End date"
              label-for="event_end_date"
              :event_end_date="event_end_date"
              class="form-group-event-date"
              :class="{
                'm-date-picker-doomyoga': client_name == 'DY',
                'm-date-picker-mid': client_name == 'MID',
              }"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_end_date"
              >
                Please select date
              </p>
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_select_end_date"
              >
                Please select end date after start date
              </p>
              <mDatePicker
                v-model="_event_end_date"
                :multi="multidate"
                :format="formatDate"
                lang="en"
                :disp="[
                  'Sun',
                  'Mon',
                  'Tue',
                  'Wed',
                  'Thu',
                  'Fri',
                  'Sat',
                  '',
                  '',
                  'Cancel',
                  'OK',
                ]"
              ></mDatePicker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        md="6"
        v-else-if="
          is_event_recurring == null ||
          is_event_recurring == 0 ||
          recurrence == 'no_fixed_time'
        "
      >
        <b-row>
          <b-col>
            <b-form-group
              :label="field_name + ' date'"
              label-for="event_date"
              :event_date="event_date"
              class="form-group-event-date"
              :class="{
                'm-date-picker-doomyoga': client_name == 'DY',
                'm-date-picker-mid': client_name == 'MID',
              }"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_date"
              >
                Please select date
              </p>
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_select_date"
              >
                Please select future date(s)
              </p>
              <mDatePicker
                v-model="_event_date"
                :format="formatDate"
                :multi="recurrence == 'no_fixed_time'"
                lang="en"
                :disp="[
                  'Sun',
                  'Mon',
                  'Tue',
                  'Wed',
                  'Thu',
                  'Fri',
                  'Sat',
                  '',
                  '',
                  'Cancel',
                  'OK',
                ]"
              ></mDatePicker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6">
        <b-row>
          <b-col>
            <b-form-group
              :label="field_name + ' time'"
              class="form-group-event-time"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <p
                class=""
                :class="{
                  'error_validation_message_p_dy mx-0': client_name == 'DY',
                  error_validation_message_p_mid: client_name == 'MID',
                }"
                v-if="invalid_time"
              >
                Please select time
              </p>
              <b-row>
                <b-col class="pr-0">
                  <b-form-group
                    label="From"
                    label-for="from_time"
                    class="form-group-small-time"
                    label-cols-xl="3"
                    label-cols-md="3"
                    content-cols-xl="9"
                    content-cols-md="9"
                    :class="{
                      'form-group-time-doomyoga': client_name == 'DY',
                      'form-group-time-mid': client_name == 'MID',
                    }"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                      'form-label-mid': client_name == 'MID',
                    }"
                    ><b-form-timepicker
                      v-model="_from_time"
                      locale="en"
                      placeholder="Select time"
                      minutes-step="10"
                    ></b-form-timepicker
                  ></b-form-group>
                </b-col>
                <b-col class="pl-0">
                  <b-form-group
                    label="To"
                    label-for="to_time"
                    class="form-group-small-time"
                    label-cols-xl="3"
                    label-cols-md="3"
                    content-cols-xl="9"
                    content-cols-md="9"
                    :class="{
                      'form-group-time-doomyoga': client_name == 'DY',
                      'form-group-time-mid': client_name == 'MID',
                    }"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                      'form-label-mid': client_name == 'MID',
                    }"
                  >
                    <b-form-timepicker
                      v-model="_to_time"
                      locale="en"
                      placeholder="Select time"
                      minutes-step="10"
                    ></b-form-timepicker> </b-form-group></b-col
              ></b-row>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col md="6">
        <b-row>
          <b-col>
            <b-form-group
              :label="field_name + ' date'"
              label-for="event_date"
              :class_date="event_date"
              class="form-group-event-date"
              :class="{
                'm-date-picker-doomyoga': client_name == 'DY',
                'm-date-picker-mid': client_name == 'MID',
              }"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <p class="'error_validation_message_p_dy mx-0'" v-if="invalid_date">
                Please select date
              </p>
              <p
                class="'error_validation_message_p_dy mx-0'"
                v-if="invalid_select_date"
              >
                Please select future date(s)
              </p>
              <mDatePicker
                v-model="_event_date"
                id="event_date"
                :format="formatDate"
                :value="event_date"
                :multi="multidate"
                required
                lang="en"
                :disp="[
                  'Sun',
                  'Mon',
                  'Tue',
                  'Wed',
                  'Thu',
                  'Fri',
                  'Sat',
                  '',
                  '',
                  'Cancel',
                  'OK',
                ]"
              ></mDatePicker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="6">
        <b-row>
          <b-col>
            <b-form-group
              :label="field_name + ' time'"
              class="form-group-event-time"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <p class="'error_validation_message_p_dy mx-0'" v-if="invalid_time">
                Please select time
              </p>
              <b-row>
                <b-col class="pr-0">
                  <b-form-group
                    label="From"
                    label-for="from_time"
                    class="form-group-small-time"
                    :class="{
                      'form-group-time-doomyoga': client_name == 'DY',
                      'form-group-time-mid': client_name == 'MID',
                    }"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                      'form-label-mid': client_name == 'MID',
                    }"
                    ><b-form-timepicker
                      v-model="_from_time"
                      locale="en"
                      placeholder="Select time"
                      minutes-step="10"
                      required
                    ></b-form-timepicker
                  ></b-form-group>
                </b-col>
                <b-col class="pr-0">
                  <b-form-group
                    label="To"
                    label-for="to_time"
                    class="form-group-small-time"
                    :class="{
                      'form-group-time-doomyoga': client_name == 'DY',
                      'form-group-time-mid': client_name == 'MID',
                    }"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                      'form-label-mid': client_name == 'MID',
                    }"
                  >
                    <b-form-timepicker
                      v-model="_to_time"
                      locale="en"
                      placeholder="Select time"
                      minutes-step="10"
                      required
                    ></b-form-timepicker> </b-form-group></b-col
              ></b-row>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import $, { event } from "jquery";
import mDatePicker from "@/components/multi-date-picker/multiDatePicker.vue";

export default {
  name: "EventDateTimeData",
  props: [
    "client_name",
    "field_name",

    "is_event_recurring",
    "recurrence",
    "repeat",
    "invalid_occurs_on",
    "occurs_on",
    "invalid_occurs_on_month",
    "occurs_on_month",
    "invalid_start_date",
    "invalid_select_start_date",
    "event_start_date",
    "invalid_end_date",
    "invalid_select_end_date",
    "event_end_date",

    "multidate",
    "event_date",
    "invalid_date",
    "invalid_select_date",
    "from_time",
    "to_time",
    "invalid_time",
  ],

  components: { mDatePicker },
  data() {
    return {
      recurrence_options: [
        { label: "Daily", code: "day" },
        { label: "Weekly", code: "week" },
        { label: "Monthly", code: "month" },
        { label: "No fixed time", code: "no_fixed_time" },
      ],
      occurs_on_days: [
        { text: "Sun", value: "Sunday" },
        { text: "Mon", value: "Monday" },
        { text: "Tue", value: "Tuesday" },
        { text: "Wed", value: "Wednesday" },
        { text: "Thu", value: "Thursday" },
        { text: "Fri", value: "Friday" },
        { text: "Sat", value: "Saturday" },
      ],
      optionsRecurrenceDaily: [1, 2, 3, 4, 5, 6, 7],
      optionsRecurrenceMonthly: [1, 2, 3],
      occurs_on_day_month: [],
    };
  },
  mounted() {
    this.occurs_on_day_month = Array.from({ length: 31 }, (_, i) => i + 1);
  },
  computed: {
    _recurrence: {
      get() {
        return this.recurrence;
      },
      set(value) {
        console.log(value);
        this.$emit("update:recurrence", value);
        if (value == "no_fixed_time") {
          this.$emit("update:multidate", true);
        } else {
          this.$emit("update:multidate", false);
        }
        let temp = this;
        setTimeout(function () {
          console.log(temp.recurrence);
          temp.changeRecurrence();
        }, 500);
      },
    },
    _repeat: {
      get() {
        return this.repeat;
      },
      set(value) {
        this.$emit("update:repeat", value);
      },
    },
    _occurs_on: {
      get() {
        return this.occurs_on;
      },
      set(value) {
        console.log(value);
        this.$emit("update:occurs_on", value);
      },
    },
    _occurs_on_month: {
      get() {
        return this.occurs_on_month;
      },
      set(value) {
        this.$emit("update:occurs_on_month", value);
      },
    },
    _event_start_date: {
      get() {
        return this.event_start_date;
      },
      set(value) {
        console.log(value);
        this.$emit("update:event_start_date", value);
      },
    },
    _event_end_date: {
      get() {
        return this.event_end_date;
      },
      set(value) {
        this.$emit("update:event_end_date", value);
      },
    },
    _event_date: {
      get() {
        return this.event_date;
      },
      set(value) {
        console.log(value);
        this.$emit("update:event_date", value);
      },
    },
    _from_time: {
      get() {
        return this.from_time;
      },
      set(value) {
        this.$emit("update:from_time", value);
      },
    },
    _to_time: {
      get() {
        return this.to_time;
      },
      set(value) {
        this.$emit("update:to_time", value);
      },
    },
  },
  methods: {
    changeRecurrence() {
      console.log(
        "change recurrence ",
        this.recurrence,
        this.is_event_recurring
      );
      if (this.recurrence == null) {
        // this.repeat = null;
        this.$emit("update:repeat", null);
        // this.occurs_on = [];
        // this.occurs_on_month = null;

        this.$emit("update:occurs_on", []);
        this.$emit("update:occurs_on_month", null);
      } else {
        console.log(
          "change recurrence eeee",
          this.recurrence,
          this.is_event_recurring
        );
        if (this.recurrence == "no_fixed_time") {
          console.log(this.recurrence, this.event_date, this.multidate);
          // this.event_date = [];
          // this.multidate = true;
          this.$emit("update:event_date", []);
          this.$emit("update:multidate", true);
          console.log(this.recurrence, this.event_date, this.multidate);
        } else if (
          this.recurrence != "no_fixed_time" ||
          this.is_event_recurring == 0
        ) {
          console.log("else", this.recurrence, this.event_date, this.multidate);

          // this.event_date = null;
          // this.multidate = false;
          this.$emit("update:event_date", null);
          this.$emit("update:multidate", false);
          if (this.recurrence == "day") {
            // this.repeat = 1;
            this.$emit("update:repeat", 1);
            // this.occurs_on = [];
            // this.occurs_on_month = null;
            this.$emit("update:occurs_on", []);
            this.$emit("update:occurs_on_month", null);
          } else if (this.recurrence == "week") {
            // this.repeat = 1;
            this.$emit("update:repeat", 1);
            // this.occurs_on = [];
            // this.occurs_on_month = null;
            this.$emit("update:occurs_on", []);
            this.$emit("update:occurs_on_month", null);
          } else if (this.recurrence == "month") {
            // this.repeat = 1;
            this.$emit("update:repeat", 1);
            // this.occurs_on = [];
            // this.occurs_on_month = null;
            this.$emit("update:occurs_on", []);
            this.$emit("update:occurs_on_month", null);
          }
        }
      }
      console.log(this.recurrence, this.event_date, this.multidate);
    },
    formatDate(date) {
      // console.log(date);
      //  return date.toLocaleDateString();

      let formattedDate =
        date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
      // console.log(formattedDate);
      return formattedDate;
    },
  },
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/components/events/DateTimeData.vue